export const MAX_INVOICE_PRICE_AMOUNT = 999_999_999_999.99
export const MAX_INVOICE_PRICE_LENGTH = 14 // 12 digits + 2 decimal places
